import { Button } from 'design-system';
import { RefreshCw } from 'lucide-react';
import { useVersionPolling } from '@/shared/hooks/useVersionPolling';

export const VersionUpdateBanner = () => {
  const { hasNewVersion } = useVersionPolling();

  const handleRefresh = () => {
    window.location.reload();
  };

  if (!hasNewVersion) {
    return null;
  }

  return (
    <section className='mb-3 flex items-center justify-between gap-1 bg-gx-response px-6 py-2'>
      <p className='text-sm'>
        <strong className='mr-3'>New version available</strong>
        <span>
          Please refresh the page to ensure optimal performance and access the latest features
        </span>
      </p>
      <Button
        className='w-[250px] text-sm'
        onClick={handleRefresh}
      >
        <RefreshCw />
        Refresh now
      </Button>
    </section>
  );
};
